<div class="page-header">
    <div class="row">
        <h3>بیانیه رفع مسئولیت</h3>
    </div>
</div>
<article>
    <section class="page-section-1">
        <div class="row">
            <div class="medium-12 column">
                <p>&nbsp;</p>
                <p><span style="color: #aa0304; font-size: 14pt;font-family:'iransans-expanded';">شرکت سبدگردان آبان
                        :</span></p>
                <hr>
                <p><span style="font-size: 12pt; color: #000;">۱- به هیچ عنوان ضمانت نمی کندکه اطلاعات موجود در این
                        سایت، دقیق، کامل، به روز و یا بدون خطا باشد.</span></p>
                <p><span style="font-size: 12pt; color: #000;">۲- هیچگونه مسئولیتی در برابر تبعات ناشی از هر گونه
                        استفاده از مضامین این سایت را بر عهده نمی گیرد.</span></p>
                <p><span style="font-size: 12pt; color: #000;">۳- هیچگونه مسئولیتی در برابر صحت اطلاعات موجود در گزارش
                        های تحلیلی تهیه شده توسط کارشناسان این شرکت که بر روی این سایت قرار می گیرد بر عهده نمی گیرد و
                        نظرات ارائه شده در این گزارش ها به هیچ وجه به عنوان توصیه ای جهت خرید، فروش و یا نگهداری سهام
                        شرکت ها و سایر ابزارهای معاملاتی نمی باشد و مسئولیت استفاده از این اطلاعات با مراجعه کنندگان به
                        این سایت می باشد.</span></p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
            </div>
        </div>
    </section>
</article>